import { render, staticRenderFns } from "./StudentsV2.vue?vue&type=template&id=3300cd0f&lang=pug&"
import script from "./StudentsV2.vue?vue&type=script&lang=js&"
export * from "./StudentsV2.vue?vue&type=script&lang=js&"
import style0 from "./StudentsV2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports